// Settings is ADMIN-focused (plan.md G26 goal text: "Web: settings + Xero +
// importer screens (ADMIN-focused)"). The left nav already hides the whole
// section from non-ADMIN roles (src/lib/nav.ts's `roles: ['ADMIN']`), but a
// non-admin can still deep-link straight to /settings/* (no route-level role
// guard exists), so every write affordance in this feature independently checks
// `useIsAdmin()` and disables/hides itself rather than trusting the nav's
// visibility alone — mirroring the server's own `requireRole('ADMIN')` (or
// `requireRole('OPERATIONS','ADMIN')` for products) gate on every mutating
// config/xero/importer endpoint, so a stale client can never show a write
// control the API would reject anyway.
import { useAuth } from '../../auth/AuthContext';

export function useIsAdmin(): boolean {
  const auth = useAuth();
  return auth.activeTenant?.role === 'ADMIN';
}

/** Xero connection status + push/pull are gated `requireRole('SALES_ACCOUNTS',
 * 'ADMIN')` server-side (services/api/src/modules/xero/{connection,sync}.ts) —
 * matches BUILD_SPEC.md §6's "SALES_ACCOUNTS: ... invoices, credit notes,
 * Xero." Connect/disconnect and mapping CRUD stay ADMIN-only (`requireRole
 * ('ADMIN')`) — see `useIsAdmin` for those. */
export function useCanSyncXero(): boolean {
  const auth = useAuth();
  const role = auth.activeTenant?.role;
  return role === 'ADMIN' || role === 'SALES_ACCOUNTS';
}
